var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 217,
    viewBox: "0 0 255 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 33.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 33.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 33.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 33.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 33.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 33.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.5,
    cy: 33.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.5,
    cy: 33.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.5,
    cy: 33.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 63.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 63.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 63.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 63.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 63.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 63.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.5,
    cy: 63.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.5,
    cy: 63.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.5,
    cy: 63.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 93.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 93.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 93.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 93.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 93.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 93.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.5,
    cy: 93.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.5,
    cy: 93.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.5,
    cy: 93.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 123.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 123.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 123.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 123.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 123.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 123.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.5,
    cy: 123.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.5,
    cy: 123.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.5,
    cy: 123.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 153.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 153.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 153.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 153.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 153.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 153.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.5,
    cy: 153.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.5,
    cy: 153.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.5,
    cy: 153.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 183.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 183.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 183.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 183.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 183.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 183.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.5,
    cy: 183.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.5,
    cy: 183.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.5,
    cy: 183.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 213.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 213.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 213.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 213.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 213.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 213.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.5,
    cy: 213.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.5,
    cy: 213.5,
    r: 3.5,
    fill: "#F9BF29"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.5,
    cy: 213.5,
    r: 3.5,
    fill: "#F9BF29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsYellow);
export default __webpack_public_path__ + "static/media/dots-yellow.bfc44818a1b6606dd7c16cd5ea175d39.svg";
export { ForwardRef as ReactComponent };